import api from "api";

type TaskNotification = {
  notificationType?: string;
  challenge?: string;
  idea?: string;
};

/** Refetches what a finished background task changed, so pages show it. */
export function refreshTaskResult(notification: TaskNotification): void {
  const { notificationType, challenge, idea } = notification;
  if (notificationType === "aiChallengeFormat" && challenge) {
    api.invalidateQueries(api.challenges.get, [challenge]);
    api.invalidateQueries(api.challenges.getChallengeFormat, [challenge]);
  }
  if (notificationType === "aiFormatReview" && challenge) {
    api.invalidateQueries(api.challenges.getChallengeFormatReview, [challenge]);
  }
  if (
    (notificationType === "aiIdeaFeedback" ||
      notificationType === "aiIdeaAnonymityCheck") &&
    idea
  ) {
    api.invalidateQueries(api.ideas.get, [idea]);
  }
}
